import React from "react";
import ManagementThemedTable from "components/management/molecules/ManagementThemedTable";
import i18n from "utils/i18n";
import _ from "lodash";

const ManagementStatisticsChartsTable = ({ statistic, data }) => {

	const headers = _.map( statistic.headers, header => {
		return i18n.t(`management:statistics.general.${header}`);
	});
	
	// Prepare data
	const preparedData = _.map( data, item => {
		 let object = {};
		 _.forEach( statistic.headers, header => {
		 	object[ header ] = _.get( item, header, null )
		 })
		
		return object
	})
	
	return (
		<ManagementThemedTable
			headers={ headers }
			rows={ preparedData }
		/>
	);
}

export default ManagementStatisticsChartsTable
